<template>
	<center>
		<img src="/images/down_ibayaq.jpg" v-if="ind == 1">
		<img src="/images/tutup_sementara.jpg" v-else >
	</center>
</template>


<script type="text/javascript">
    
export default {
  
	
	
    props: {
        ind: [Array, Object],
    },
	data() {
	    return {
            form: {},

            
    	}
    },
	methods: {
	},
  mounted() {
    
   
  }
}
</script>